import type { MonospacePolicy, MonospaceRolePolicy, RawMonospacePolicy } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { compositeKey } from '~/rstore/utils/composite-key';

export const RolePolicy = withItemType<MonospaceRolePolicy>().defineCollection({
	name: 'MonospaceRolePolicy',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => compositeKey(item.roleId, item.policyId),
	meta: {
		defaultFields: ['roleId', 'policyId'],
	},
});

export const Policy = withItemType<MonospacePolicy>().defineCollection({
	name: 'MonospacePolicy',
	scopeId: MONOSPACE_SCOPE_ID,
	fields: {
		content: {},
	},
	meta: {
		defaultFields: ['id', 'name', 'content', 'isProtected'],
		endpoint: 'policies',
		fetchOnCreate: true,
		fetchOnUpdate: true,
	},
});

// This is a model for the _actual_ policy that is stored in the DB, with global ids instead of collection names
export const RawPolicy = withItemType<RawMonospacePolicy>().defineCollection({
	name: 'RawMonospacePolicy',
	scopeId: MONOSPACE_SCOPE_ID,
	fields: {
		// TODO(hannes) this is temporary until we switch API to JSON output
		content: {
			parse: (value) => typeof value === 'string' ? JSON.parse(value) : value,
		},
	},
	meta: {
		defaultFields: ['id', 'name', 'content'],
		endpoint: '/items/MonospacePolicy',
	},
});
